import React, { useEffect, useState } from "react";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import { useAnnouncementByID, useAnnouncementPushNotification } from "../hooks/useAnnouncement";
import { Spinner } from "reactstrap";

const AnnouncementPushNotificationModal = ({
  selectedRow,
  mode,
  setIsModalOpen,
}: any) => {
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
      const [isSubmitting, setIsSubmitting] = useState(false);
  

  const { data: announcementById } = useAnnouncementByID({
    enabled: !!selectedRow?.AnnouncementId,
    id: selectedRow?.AnnouncementId,
  });
  console.log("announcemetById", announcementById);

  const{mutate:pushnotification}=useAnnouncementPushNotification()

  useEffect(() => {
    setTitle(announcementById?.data?.AnnouncementTitle || "");
    setMessage(announcementById?.data?.AnnouncementMessage || "");
  }, [announcementById]);

  const handleSubmit=(e:React.FormEvent)=>{
    e.preventDefault()
 if (isSubmitting) return;
   const payload={
AnnouncementId:selectedRow?.AnnouncementId,
AnnouncementTitle:title,
AnnouncementMessage:message
    }
    setIsSubmitting(true);
    pushnotification(payload,{onSuccess:()=>{
      setIsModalOpen(false)
      setIsSubmitting(false);
    }})
  }

  const isLoading = !announcementById?.data;
  return (
    <>
      {isLoading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "60vh" }}
        >
          <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
          {/* <span className="ms-3">Loading SGPI Brands...</span> */}
        </div>
      ) : (
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column" }}>
          <CustomInput
            label="Title"
            type="text"
            style={{
              backgroundColor: "transparent",
              border: "0.2px solid #d4d4d4",
              flex: 1,
            }}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <CustomInput
            label="Message"
            type="textarea"
            style={{
              backgroundColor: "transparent",
              border: "0.2px solid #d4d4d4",
              flex: 1,
            }}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <div style={{ marginTop: "20px" }}>
            <button disabled={isSubmitting}  className="btn btn-primary">
              {isSubmitting
                   ? "Submitting..."
                   : "Submit"}
            </button>
            <button
              onClick={() => setIsModalOpen(false)}
              className="btn btn-light"
              style={{ color: "gray", marginLeft: "10px" }}
            >
              Cancel
            </button>
          </div>
        </form>
      )}
    </>
  );
};
export default AnnouncementPushNotificationModal;
